import { Intensity } from './user-inputs';

export const STACK_COEFFICIENTS: { [key: number]: number } = {
  1: 0.000145,
  2: 0.00029,
  3: 0.000435,
};

export const WIND_COEFFICIENTS: { [key: number]: { [key: number]: number } } = {
  1: {
    1: 0.000319,
    2: 0.00042,
    3: 0.000494,
  },
  2: {
    1: 0.000246,
    2: 0.000325,
    3: 0.000382,
  },
  3: {
    1: 0.000174,
    2: 0.000231,
    3: 0.000271,
  },
  4: {
    1: 0.000104,
    2: 0.000137,
    3: 0.000161,
  },
  5: {
    1: 0.000032,
    2: 0.000042,
    3: 0.000049,
  },
};

export const VENTILATION_RATES: { [key: number]: { [key in Intensity]: [number, number, number][] } } = {
  1: {
    [Intensity.sedentary]: [
      [1,1,0.40],
      [2,2,0.34],
      [3,5,0.25],
      [6,10,0.16],
      [11,15,0.10],
      [16,20,0.08],
      [21,30,0.06],
      [31,60,0.07],
      [61,80,0.08],
      [81,999,0.09],
    ],
    [Intensity.light]: [
      [1,1,1.01],
      [2,2,0.83],
      [3,5,0.63],
      [6,10,0.38],
      [11,15,0.24],
      [16,20,0.18],
      [21,30,0.15],
      [31,70,0.16],
      [71,80,0.17],
      [81,999,0.18],
    ],
    [Intensity.moderate]: [
      [1,1,1.82],
      [2,2,1.54],
      [3,5,1.12],
      [6,10,0.71],
      [11,15,0.47],
      [16,20,0.38],
      [21,40,0.34],
      [41,50,0.35],
      [51,60,0.37],
      [61,70,0.34],
      [71,80,0.36],
      [81,999,0.38],
    ],
    [Intensity.vigorous]: [
      [1,1,3.57],
      [2,2,2.87],
      [3,5,2.11],
      [6,10,1.38],
      [11,15,0.91],
      [16,20,0.69],
      [21,30,0.64],
      [31,40,0.62],
      [41,50,0.63],
      [51,60,0.64],
      [61,70,0.61],
      [71,80,0.63],
      [81,999,0.70],
    ],
  },
  2: {
    [Intensity.sedentary]: [
      [1,1,0.42],
      [2,2,0.35],
      [3,5,0.25],
      [6,10,0.16],
      [11,15,0.09],
      [16,20,0.07],
      [21,50,0.06],
      [51,80,0.07],
      [81,999,0.08],
    ],
    [Intensity.light]: [
      [1,1,1.04],
      [2,2,0.89],
      [3,5,0.60],
      [6,10,0.38],
      [11,15,0.22],
      [16,20,0.17],
      [21,40,0.15],
      [41,60,0.16],
      [61,70,0.14],
      [71,999,0.16],
    ],
    [Intensity.moderate]: [
      [1,1,1.87],
      [2,2,1.58],
      [3,5,1.11],
      [6,10,0.71],
      [11,15,0.43],
      [16,20,0.35],
      [21,30,0.32],
      [31,40,0.30],
      [41,50,0.32],
      [51,60,0.33],
      [61,70,0.28],
      [71,80,0.30],
      [81,999,0.33],
    ],
    [Intensity.vigorous]: [
      [1,1,3.24],
      [2,2,2.81],
      [3,5,1.90],
      [6,10,1.33],
      [11,15,0.85],
      [16,20,0.69],
      [21,30,0.63],
      [31,40,0.59],
      [41,50,0.64],
      [51,60,0.61],
      [61,70,0.53],
      [71,80,0.58],
      [81,999,0.63],
    ],
  },
};
